import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-button',
  template: `
    <button
        mat-icon-button
        color="warn"
        (click)="remove()"
        data-cy="borrower-status-reason-save"
      ><mat-icon>delete_outline</mat-icon></button>
  `
})
export class RepeatDeleteComponent extends FieldType {
  remove() {
    if (this.field.parent?.parent?.props) {
      const i = this.field.parent?.key || 0;
      this.field.parent.parent.props.remove(i);
    }
  }
}
